import { defineStore } from 'pinia'

export const useDialogStore = defineStore('dialog', {
    state: () => ({
        visible: false,
        title: '',
        message: ''
    }),
    actions: {
        open({ title, message }) {
            this.title   = title
            this.message = message
            this.visible = true
        },
        close() {
            this.visible = false
        }
    }
})